import { logger } from '@exchange/libs/utils/simple-logger/src';

export default function registerError() {
  return (error) => {
    /* https://v3.router.vuejs.org/api/#router-onerror */
    logger.log('router onerror', error);
    throw error;
  };
}
